<template>
  <v-row class="main-container">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>
    <v-alert v-model="alert" :type="alertType" dismissible>{{ alertMessage }}</v-alert>

    <!-- Create account dialog -->
    <v-dialog
      v-if="dialogCreateAccount"
      v-model="dialogCreateAccount"
      persistent
      width="800"
    >
      <v-card color="white" flat>
        <v-card-title class="dialog-header-title">Create Account User</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <span>Account type:</span>
              <v-select
                class="form-control"
                :items="accountTypes"
                item-value="account_type"
                item-text="name"
                solo
                flat
                v-model="accountPlaceHolder.account_type"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <span>First name:</span>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                v-model="accountPlaceHolder.first_name"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <span>Last name:</span>
              <input class="form-control" v-model="accountPlaceHolder.last_name" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="4">
              <span>Phone number:</span>
              <input class="form-control" v-model="accountPlaceHolder.phone_number" />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <span>Email address:</span>
              <input
                type="email"
                autocomplete="off"
                class="text-lowercase form-control"
                v-model="accountPlaceHolder.email"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <span>New Password:</span>
              <v-text-field
                class="form-control"
                v-model="accountPlaceHolder.password"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                hint="At least 6 characters"
                counter
                @click:append="show1 = !show1"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              tile
              depressed
              color="primary"
              class="font-weight-bold mr-2"
              @click="createAccount()"
              >CREATE</v-btn
            >
            <v-btn
              tile
              depressed
              color="error"
              class="font-weight-bold ml-2"
              @click="onCancel()"
              >CANCEL</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End of create account dialog -->
    <!-- Assign customer dialog -->
    <v-dialog
      v-if="dialogAssignCustomer"
      v-model="dialogAssignCustomer"
      persistent
      width="500"
    >
      <v-card color="white">
        <v-card-title class="dialog-header-title">{{
          dialogLabelAssignCustomer
        }}</v-card-title>
        <v-row>
          <v-col class="px-5 my-2">
            <v-autocomplete
              class="form-control"
              :items="sortedCompanies"
              label="Select company"
              v-model="assignCompanyID"
              return-object
              item-text="label"
              flat
              solo
              clearable
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="end">
            <v-btn
              tile
              depressed
              color="primary"
              class="font-weight-bold text-button mr-2"
              @click="assignAccountToCustomer()"
              >CONFIRM</v-btn
            >
            <v-btn
              tile
              depressed
              color="error"
              class="font-weight-bold text-button ml-2"
              @click="onCancel()"
              >CANCEL</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End of assign customer dialog -->

    <v-dialog v-if="dialogConfirm" v-model="dialogConfirm" persistent max-width="600">
      <v-form>
        <v-card color="white" flat>
          <v-card-title class="dialog-header-title">{{
            dialogConfirmTitle
          }}</v-card-title>
          <v-card-text class="body-1 black--text pt-2">{{
            dialogConfirmMsg
          }}</v-card-text>

          <v-card-actions>
            <v-row justify="end">
              <v-btn
                class="font-weight-bold mr-2"
                color="primary"
                tile
                depressed
                @click="manageUserAccountAccess(valid_access_value)"
                >YES</v-btn
              >

              <v-btn
                class="font-weight-bold ml-2"
                color="error"
                tile
                depressed
                @click="dialogConfirm = false"
                >NO</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-if="dialogResetPW" v-model="dialogResetPW" persistent max-width="300">
      <v-form>
        <v-card>
          <v-card-title class="dialog-header-title">Reset Password</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <span>New Password:</span>
                <v-text-field
                  class="form-control"
                  v-model="accountPlaceHolder.password"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  hint="At least 6 characters"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-row justify="end">
              <v-btn
                class="font-weight-bold mr-2"
                color="primary"
                tile
                depressed
                @click="resetPassword"
                >RESET</v-btn
              >
              <v-btn
                class="font-weight-bold ml-2"
                color="error"
                tile
                depressed
                @click="dialogResetPW = false"
                >CANCEL</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <dialog-user-account
      v-if="dialogUserAccount"
      :dialog="dialogUserAccount"
      :useraccount="useraccount"
      v-on:dialog-close="onDialogClose"
    ></dialog-user-account>

    <v-row no-gutters>
      <v-col>
        <v-toolbar flat class="sub-toolbar" height="50px">
          <v-row no-gutters>
            <v-col cols="12" sm="6" md="4">
              <v-row>
                <v-icon color="primary" size="30" class="mr-2">mdi-account-circle</v-icon>
                <v-toolbar-title class="primary--text">Account Users</v-toolbar-title>
              </v-row>
            </v-col>

            <v-col cols="12" sm="6" md="4" class="pb-1">
              <v-btn-toggle
                class="v-btn-toggle-new-quotation"
                mandatory
                dense
                v-model="filterAccountUsers"
              >
                <v-btn text :value="0">AF Users</v-btn>
                <v-btn text :value="1">Company Users</v-btn>
                <v-btn text :value="2">All</v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <input
                class="form-control"
                v-model="searchAccountUsers"
                placeholder="Search table"
              />
            </v-col>

            <v-col cols="12" sm="6" md="2" class="d-flex justify-end">
              <v-btn small outlined color="primary" @click="onNewAccountUser()">
                <v-icon>add</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="px-2">
        <v-card color="white" flat>
          <v-data-table
            dense
            :search="searchAccountUsers"
            :headers="accountHeader"
            :items="sortedAccountsList"
            :footer-props="{
              itemsPerPageOptions: [20, 30, 40, 50, -1],
            }"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.header.text }}</span>
                </template>

                <span>{{ props.header.description }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-left">
                  {{ `${item.first_name} ${item.last_name}` }}
                </td>
                <td class="text-left">
                  {{ item.account_type == "AFC" ? "Company User" : "AF User" }}
                </td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <td class="text-center" v-on="on">
                      {{ item.company_name != null ? item.company_short_name : "" }}
                    </td>
                  </template>
                  {{ item.company_name }}
                </v-tooltip>
                <td class="text-left">{{ item.email }}</td>
                <td class="text-center">{{ item.phone_number }}</td>
                <td class="text-center column-icon">
                  <v-icon v-if="item.email_validated" color="#7FB800"
                    >fa-check-circle</v-icon
                  >
                  <v-icon v-else color="#8F2D56">fa-times-circle</v-icon>
                </td>
                <td class="text-center column-icon">
                  <v-icon v-if="item.valid_access" color="#7FB800"
                    >fa-check-circle</v-icon
                  >
                  <v-icon v-else color="#8F2D56">fa-times-circle</v-icon>
                </td>
                <td class="text-center">
                  {{ item.created != null ? item.created.substring(0, 10) : "N/A" }}
                </td>
                <td class="justify-center px-0">
                  <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" color="primary" icon small dark>
                        <v-icon>menu</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <!-- Set disabled for assign customer menu option if account is not of type customer -->
                      <v-list-item
                        v-for="(el, i) in onMenuOptions(item)"
                        :key="i"
                        :disabled="item.account_type == ACCOUNT_CUSTOMER && i == 0"
                        @click="onAccountMenu(el, item)"
                      >
                        <v-list-item-action class="mr-2">
                          <v-icon small :color="el.color">{{ el.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{ el.title }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../const";

export default {
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,
      alert: false,
      alertType: "success",
      alertMessage: "",
      // showAlert: false,
      dialogCreateAccount: false,
      dialogLabelCreateAccount: "",
      showPassword: false,

      dialogConfirm: false,
      dialogConfirmTitle: "",
      dialogConfirmMsg: "",
      valid_access_value: null,

      dialogAssignCustomer: false,
      dialogAssignCustomerModel: "",
      dialogLabelAssignCustomer: "",

      dialogResetPW: false,
      show1: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 6 || "Min 6 characters",
      },

      dialogUserAccount: false,
      useraccount: null,

      ACCOUNT_ADMIN: constant.ACCOUNT_ADMIN,
      ACCOUNT_CUSTOMER: constant.ACCOUNT_CUSTOMER,

      postResponse: [],
      customers: [],
      companies: [],
      assignUID: null,
      assignCompanyID: null,

      accountTypes: [
        {
          account_type: "AFU",
          name: "AF User",
        },
        {
          account_type: "AFC",
          name: "Company User",
        },
      ],
      accountPlaceHolder: {
        uid: null,
        first_name: null,
        last_name: null,
        account_type: null,
        password: "",
        email: null,
        phone_number: null,
      },

      filterAccountUsers: 0,
      searchAccountUsers: null,

      updateAccountList: false,
      empty_account_list: false,
      accounts: [],
      accountHeader: [
        {
          text: "Fullname",
          align: "center",
          description: "Account User Fullname",
          value: "first_name",
        },
        {
          text: "Type",
          align: "center",
          description: "Account type type",
          value: "type",
        },
        {
          text: "Company name",
          align: "center",
          description: "Company this account is attached to",
          value: "company_name",
        },
        {
          text: "E-mail",
          align: "center",
          description: "Account e-mail",
          value: "email",
        },
        {
          text: "Phone",
          align: "center",
          description: "Phone number",
          value: "phone_number",
        },
        {
          text: "Validated",
          align: "center",
          description: "E-mail validated",
          value: "approved",
        },
        {
          text: "Status",
          align: "center",
          description: "Valid Access",
          value: "approved",
        },
        {
          text: "Created",
          align: "center",
          description: "Date account created",
          value: "created",
        },
        {
          text: "Actions",
          align: "center",
          description: "Manage accounts",
          value: "action",
          sortable: false,
        },
      ],
    };
  },

  async created() {
    // verify user token
    await this.$root.verify_user_token();
  },

  mounted() {
    this.loadAccountList();
  },

  watch: {
    /**
     * on Filter Account users by AFU | AFC | All
     */
    filterAccountUsers: function () {
      this.loadAccountList();
    },
  },

  methods: {
    /**
     * Load Account user list
     */
    loadAccountList() {
      // load the blockui
      this.$root.blockUImsg = "Loading account users";
      this.$root.blockUIshow = true;
      let requestString = "/users?account_type=AFU";

      // filter based the selected filter
      switch (this.filterAccountUsers) {
        case 1:
          requestString = "/users?account_type=AFC";
          break;
        case 2:
          requestString = "/users";
          break;
        default:
          break;
      }

      this.$auth
        .get(requestString)
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.accounts = resp.data.data;
          } else {
            this.accounts = [];
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
          }
          this.$root.blockUIshow = false;
        })
        .catch((err) => {
          console.log(err);
          this.$root.blockUIshow = false;
        });
    },

    /**
     * Load company list
     */
    loadCompanies() {
      var self = this;
      return new Promise((success, reject) => {
        self.$https
          .get("/api/company/list")
          .then((resp) => {
            self.companies = resp.data.data;
            success();
          })
          .catch((err) => {
            console.log(err);
            reject();
          });
      });
    },

    onDialogClose() {
      this.dialogUserAccount = false;
    },

    onCancel: function () {
      this.dialogCreateAccount = false;
      this.dialogAssignCustomer = false;
      // this.resetAccountPlaceholder();
    },
    onMenuOptions(item) {
      var menu = [
        {
          id: "assign",
          icon: "fa-link",
          color: "primary",
          title: "Assign customer",
        },
        {
          id: "verify",
          icon: "fa-user-check",
          color: "primary",
          title: "Verify email",
        },
        {
          id: "email_verification",
          icon: "fa-envelope-open",
          color: "primary",
          title: "Send email verification",
        },
        {
          id: "pw_link",
          icon: "fa-envelope",
          color: "error",
          title: "Send password reset link",
        },
        {
          id: "pw_reset",
          icon: "fa-key",
          color: "error",
          title: "Reset password",
        },
        { id: "ban", icon: "fa-ban", color: "error", title: "Disable User" },
      ];

      if (item.valid_access == true) {
        return menu;
      } else {
        menu = [
          {
            id: "assign",
            icon: "fa-link",
            color: "blue",
            title: "Assign customer",
          },
          {
            id: "verify",
            icon: "fa-user-check",
            color: "green",
            title: "Verify email",
          },
          {
            id: "email_verification",
            icon: "fa-envelope-open",
            color: "blue",
            title: "Send email verification",
          },
          {
            id: "pw_link",
            icon: "fa-envelope",
            color: "red",
            title: "Send password reset link",
          },
          {
            id: "pw_reset",
            icon: "fa-key",
            color: "red",
            title: "Reset password",
          },
          {
            id: "enable",
            icon: "fa-unlock-alt",
            color: "green",
            title: "Enable User",
          },
        ];
        return menu;
      }
    },

    /**
     * open the dialog for adding a new account user
     */
    onNewAccountUser() {
      this.dialogCreateAccount = true;
      this.resetAccountPlaceHolder();
    },

    /**
     * Create a new account user
     */
    createAccount: function () {
      // validate form
      if (this.accountPlaceHolder.account_type == null) {
        this.alert = true;
        this.alertMessage = "Please select an account type";
        this.alertType = "warning";
        return;
      }
      if (this.accountPlaceHolder.first_name == null) {
        this.alert = true;
        this.alertMessage = "Please input user first name";
        this.alertType = "warning";
        return;
      }
      if (this.accountPlaceHolder.last_name == null) {
        this.alert = true;
        this.alertMessage = "Please input user last name";
        this.alertType = "warning";
        return;
      }
      // if (this.accountPlaceHolder.phone_number == null) {
      //   this.alert = true;
      //   this.alertMessage = "Please provide user phone number";
      //   this.alertType = "warning";
      //   return;
      // }
      if (this.accountPlaceHolder.email == null) {
        this.alert = true;
        this.alertMessage = "Please provide user email address";
        this.alertType = "warning";
        return;
      }
      if (this.accountPlaceHolder.password == null) {
        this.alert = true;
        this.alertMessage = "Please provide user password";
        this.alertType = "warning";
        return;
      }

      this.$root.blockUImsg = "Creating account user...";
      this.$root.blockUIshow = true;
      this.$auth
        .post(`/admin/useraccount`, this.accountPlaceHolder)
        .then((resp) => {
          if (resp.data.status == "OK") {
            this.resetAccountPlaceHolder();
            this.loadAccountList();
            this.snackbarColor = "success";
            this.dialogCreateAccount = false;
          } else {
            this.snackbarColor = "error";
          }
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarMsg = resp.data.msg;
          console.log(resp);
        })
        .catch((err) => {
          console.log(err);
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
        });
    },

    onAccountMenu: function (item, account) {
      switch (item.id) {
        case "assign":
          this.assignAccountToCustomerDialog(account);
          break;
        case "verify":
          this.verifyEmail(account);
          break;
        case "email_verification":
          this.sendEmailVerification(account);
          break;
        case "pw_link":
          this.sendPasswordResetLink(account);
          break;
        case "pw_reset":
          this.onResetPassword(account);
          break;
        case "ban":
          this.onDisbaleUserAccount(account);
          break;
        case "enable":
          this.onEnableUserAccount(account);
          break;
      }
    },

    /**
     * Manually verify user email
     * @param {object} account
     */
    verifyEmail(account) {
      this.$root.blockUImsg = "Verifying user email...";
      this.$root.blockUIshow = true;
      this.$auth
        .post(`/admin/verify_email/${account.uid}`)
        .then((resp) => {
          if (resp.data.status == "OK") {
            this.loadAccountList();
            this.snackbarColor = "success";
          } else {
            this.snackbarColor = "error";
          }
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarMsg = resp.data.msg;
          console.log(resp);
        })
        .catch((err) => {
          console.log(err);
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
        });
    },

    /**
     * send email verification
     * @param {object} account
     */
    sendEmailVerification(account) {
      this.$root.blockUImsg = "Sending email verification...";
      this.$root.blockUIshow = true;
      this.$auth
        .post(`/admin/email_verification/${account.email}`)
        .then((resp) => {
          if (resp.data.status == "OK") {
            this.loadAccountList();
            this.snackbarColor = "success";
          } else {
            this.snackbarColor = "error";
          }
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarMsg = resp.data.msg;
          console.log(resp);
        })
        .catch((err) => {
          console.log(err);
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
        });
    },

    /**
     * send a reset user account password email to user
     * @param {object} account
     */
    sendPasswordResetLink(account) {
      this.$root.blockUImsg = "Sending password reset link email...";
      this.$root.blockUIshow = true;
      this.$auth
        .post(`/admin/reset_password_link/${account.email}`)
        .then((resp) => {
          if (resp.data.status == "OK") {
            this.loadAccountList();
            this.snackbarColor = "success";
          } else {
            this.snackbarColor = "error";
          }
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarMsg = resp.data.msg;
          console.log(resp);
        })
        .catch((err) => {
          console.log(err);
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
        });
    },

    onResetPassword(account) {
      this.accountPlaceHolder = account;
      this.dialogResetPW = true;
    },

    /**
     * manually reset user account password
     * @param {object} account
     */
    resetPassword() {
      this.$root.blockUImsg = "Resetting user password...";
      this.$root.blockUIshow = true;
      this.$auth
        .put(`/admin/reset_password`, this.accountPlaceHolder)
        .then((resp) => {
          if (resp.data.status == "OK") {
            this.loadAccountList();
            this.snackbarColor = "success";
          } else {
            this.snackbarColor = "error";
          }
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarMsg = resp.data.msg;
          console.log(resp);
        })
        .catch((err) => {
          console.log(err);
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
        })
        .finally(() => {
          this.resetAccountPlaceHolder();
          this.dialogResetPW = false;
        });
    },

    resetAccountPlaceHolder() {
      this.accountPlaceHolder.uid = null;
      this.accountPlaceHolder.first_name = null;
      this.accountPlaceHolder.last_name = null;
      this.accountPlaceHolder.account_type = null;
      this.accountPlaceHolder.password = "";
      this.accountPlaceHolder.email = null;
      this.accountPlaceHolder.phone_number = null;
    },

    onDisbaleUserAccount(account) {
      this.valid_access_value = "disable";
      this.dialogConfirmTitle = `Disabling ${account.email}?`;
      this.dialogConfirmMsg = `Are you sure you want to disable ${account.first_name} ${account.last_name}?`;
      this.accountPlaceHolder = account;
      this.dialogConfirm = true;
    },

    onEnableUserAccount(account) {
      this.valid_access_value = "enable";
      this.dialogConfirmTitle = `Enabling ${account.email}?`;
      this.dialogConfirmMsg = `Are you sure you want to enable ${account.first_name} ${account.last_name}?`;
      this.accountPlaceHolder = account;
      this.dialogConfirm = true;
    },

    /**
     * Enable or Disable a user account
     *
     */
    manageUserAccountAccess(value) {
      if (value == "disable") {
        this.$root.blockUImsg = "Disabling User Access";
        this.$root.blockUIshow = true;
        this.$auth
          .put(`/user/valid_access/${this.accountPlaceHolder.uid}/false`)
          .then((resp) => {
            if (resp.data.status == "OK") {
              this.snackbarColor = "success";
              this.snackbarMsg = `Disabled user ${this.accountPlaceHolder.email} successfully`;
            } else {
              this.snackbarColor = "error";
              this.snackbarMsg = resp.data.msg;
            }
            this.$root.blockUIshow = false;
            this.showSnackbar = true;
            console.log(resp);
          })
          .catch((err) => {
            console.log(err);
            this.$root.blockUIshow = false;
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = err;
          })
          .finally(() => {
            this.resetAccountPlaceHolder();
            this.dialogConfirm = false;
            this.loadAccountList();
          });
      } else {
        this.$root.blockUImsg = "Enabling User Access";
        this.$root.blockUIshow = true;
        this.$auth
          .put(`/user/valid_access/${this.accountPlaceHolder.uid}/true`)
          .then((resp) => {
            if (resp.data.status == "OK") {
              this.snackbarColor = "success";
              this.snackbarMsg = `Enabled user ${this.accountPlaceHolder.email} successfully`;
            } else {
              this.snackbarColor = "error";
              this.snackbarMsg = resp.data.msg;
            }
            this.$root.blockUIshow = false;
            this.showSnackbar = true;
            console.log(resp);
          })
          .catch((err) => {
            console.log(err);
            this.$root.blockUIshow = false;
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = err;
          })
          .finally(() => {
            this.resetAccountPlaceHolder();
            this.dialogConfirm = false;
            this.loadAccountList();
          });
      }
    },

    assignAccountToCustomerDialog: function (customer) {
      this.dialogLabelAssignCustomer = "Assign customer to account";
      this.assignUID = customer.uid;

      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;
      this.loadCompanies().then(() => {
        this.dialogAssignCustomer = true;
        this.$root.blockUIshow = false;
      });
    },

    async assignAccountToCustomer() {
      this.$root.blockUImsg = "Assigning user...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.put(
        `/api/admin/assign/uid/${this.assignUID}/company/${this.assignCompanyID.company_id}`
      );
      if (resp.data.status == "OK") {
        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
        this.assignUID = null;
        this.assignCompanyID = null;
        this.dialogAssignCustomer = false;
        this.loadAccountList();
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }
      this.$root.blockUIshow = false;
    },
  },

  computed: {
    sortedCompanies: function () {
      return this.companies.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    sortedAccountsList: function () {
      return this.accounts.sort(function (a, b) {
        return new Date(b.created) - new Date(a.created);
      });
    },
  },
};
</script>
<style>
.v-btn-style {
  text-transform: none;
  text-align: left;
  /* font-size: 90%; */
}

.admin-dialog-container {
  padding: 0 30px;
}

.admin-dialog-container .sub-container-row-item {
  padding: 2px 20px;
}

.admin-dialog-container .sub-container-row-item .flex {
  line-height: 2.5;
}
</style>
